import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const CommissionInvoiceReportConfig: ReportConfigBase = {
  type: EReportTypes.CommissionInvoice,
  endpoint: "order",
  reportKey: "orders",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Commission Invoice Report provides detailed information about the invoices used in the calculation of a commission",
    url: "https://help.commonsku.com/knowledge/commissions-report",
  },
};

export default CommissionInvoiceReportConfig;
